<template>
    <div class="row" v-for="(item, index) in list" :key="index">
        <SelectSku
            :label="item.title"
            :bgColor="bgColor"
            v-model="selectOption[item.title]"
            :item="item"
        />
    </div>
</template>

<script setup>
import { useVModel } from "@/fuel-station/useVModel";

const props = defineProps({
    modelValue: {
        type: [Object, Array, String],
        default: {
            id: 0,
            name: "Select One"
        },
    },
    list: {
        type: Array,
        default: ()=> [{
            id: 0,
            name: "Select One"
        }]
    },
    bgColor: {
        type: String,
        default: "#fff"
    }
});

const emit = defineEmits(['update:modelValue']);
const data = useVModel(props, emit, "modelValue");
const selectOption = ref({});

watch(selectOption,
    (newVal) => {
        if (selectOption.value) {
            Object.keys(selectOption.value).forEach(key => {
                if (selectOption.value[key]?.sku?.code) {
                    let index = data.value.findIndex(i => i.sku.code == selectOption.value[key]?.sku?.code && i.item.id == selectOption.value[key].item.id);
                    if (index > -1) {
                        data.value[index] = selectOption.value[key];
                    } else {
                        data.value.push(selectOption.value[key]);
                    }
                }
            });
        }
    },
    { immediate: true, deep: true }
);
</script>

<style lang="scss" scoped>
.select-label {
    top: -10px;
    left: 13px;
    z-index: 99;
    padding: 0 5px;
}


.form-select:focus {
    border-color: none !important;
    box-shadow: none !important;
}
</style>